import React from "react";
import {Container} from "react-bootstrap";
import {observer} from "mobx-react";

function PublicLayout(props){
    return (
        <div className="auth-layout">
            <Container>
                {props.children}
            </Container>
        </div>
    );
}

export default observer(PublicLayout);
